import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router'

Vue.use(Vuex);

//创建Vuex实例
const store = new Vuex.Store({
  state: {
    siteUrl: 'https://insure-test.giant.com.cn/#/',
    api: {//api链接
      common: 'https://insure-gw-test.giant.com.cn/api.php/',//接口测试
      admin: 'https://e-new-test.giant.com.cn/admin.php/',//后台接口，上传图片用
    },
    externalurl: {//外部链接
      opo: 'https://opo-test.giant.com.cn',
      club: 'https://club-test.giant.com.cn',
      crshop: 'https://jf-test.giant.com.cn',
      shop: 'https://e-test.giant.com.cn',
      banner: 'https://opo-test.giant.com.cn/opo/index.php/api/get_app_banner_list',
      chat: 'https://chat-test.giant.com.cn',
      insure: 'https://insure-test.giant.com.cn',//跳回链接
      giantqrcode: 'https://giantqrcode.kssina.com/front/toQuerybike',//跳回链接
      GIANT_CDN: 'https://giant-images.oss-cn-shanghai.aliyuncs.com/eshop-test/static',//捷安特CDN
      officialwebsite_usercenter: 'https://u-api-test.giant.com.cn/index.php',
      insure_gw: 'https://insure-gw-test.giant.com.cn',

    },

    DLINE_ENVIRONMENT: true,//true 测试环境 false 正式环境

    loginUser: {},//登录用户信息
    storePromotion: sessionStorage.getItem('storePromotion')||'0', //0--表示不是从门店推广进去，1表示是从门店推广进去的

    //theme: {
    //headerBgColor: '',
    //headerBgSrc: '',
    //headerBgColor: '#4e66ff',
    //headerBgSrc: 'linear-gradient(104deg, #4e66ff, #2bd5ff)',
    //},

    // backToPrevpage: function(){//返回上一页
    //   router.go(-1);
    // },

    browser: (function (ua) {
      var a = new Object();
      var b = {
        //micromessenger: /micromessenger/.test(ua),
        msie: /msie/.test(ua) && !/opera/.test(ua),
        opera: /opera/.test(ua),
        safari: /webkit/.test(ua) && !/chrome/.test(ua),
        firefox: /firefox/.test(ua),
        edge: /edge/.test(ua),
        trident: /trident/.test(ua),
        chrome: /chrome/.test(ua)
      };
      var vMark = "";
      for (var i in b) {
        if (b[i]) { vMark = i; break; }//"safari" == i ? "version" : i;
      }
      b.version = vMark && RegExp("(?:" + vMark + ")[\\/: ]([\\d.]+)").test(ua) ? RegExp.$1 : "0";
      b.ie = b.msie;
      b.ie6 = b.msie && parseInt(b.version, 10) == 6;
      b.ie7 = b.msie && parseInt(b.version, 10) == 7;
      b.ie8 = b.msie && parseInt(b.version, 10) == 8;

      //if(vMark == "trident") vMark = "ie11";

      a.b = vMark;
      a.v = b.version;
      a.m = /mobile/i.test(ua);
      a.wx = /MicroMessenger/i.test(ua);
      a.wxminiprogram = /miniProgram/i.test(ua);
      a.giantapp = /giantapp/i.test(ua);
      a.giantevapp = /giantevapp/i.test(ua);
      a.ios = /\(i[^;]+;( U;)? CPU.+Mac OS X/i.test(ua);
      return a;
    })(window.navigator.userAgent.toLowerCase()),

  },
  getters: {//相当于计算属性
    // themeheaderBgSrc(state){
    //   if( typeof state.theme == 'object' && state.theme ){
    //     if( state.theme.headerBgSrc && state.theme.headerBgSrc.indexOf('linear-gradient') != -1 ){
    //       return state.theme.headerBgSrc;
    //     } else if(state.theme.headerBgSrc) {
    //       return 'url('+ state.theme.headerBgSrc +')';
    //     } else {
    //       return '';
    //     }
    //   } else {
    //     return '';
    //   }
    // },
  },
  mutations: {//逻辑处理，同步
    updateState( state, data ){//通用修改值
      state[data.label] = data.data;
    },
    changeApi(state, n) {//改变api链接
      if (n) {
        for (const key in n) {
          if (n.hasOwnProperty(key)) {
            state.api[key] = n[key]
          }
        }
      }
    },
    changeExternalurl(state, n) {//改变外部链接
      if (n) {
        for (const key in n) {
          if (n.hasOwnProperty(key)) {
            state.externalurl[key] = n[key]
          }
        }
      }
    },
    changeEnvironment(state) {//正式环境撤掉“测试”标志
      state.DLINE_ENVIRONMENT = false;
    },
    changeCartCount(state, n) {//修改购物车内商品数量
      state.cartCount = n;
    },

    // updateTheme( state, n ) {//更新主题皮肤数据
    //   state.theme = {};
    //   for( let k in n ){
    //     state.theme[k] = n[k];//.toString();
    //   }
    // },

    // updateBrandList( state, n ) {//更新品牌
    //   state.brandList = n;
    // },

    updateLoginUser(state, data) {//修改登录用户数据
      state.loginUser = data;
    },
    updateSPstatus(state, data) {//门店推广状态值
      state.storePromotion = data;
    },
  },
  actions: {//类似 mothods，异步

  }
});

//正式环境
if (window.location.host == 'insure.giant.com.cn') {
  store.commit('changeApi', { 
    common: 'https://insure-gw.giant.com.cn/api.php/',
    admin: 'https://e-gw.giant.com.cn/admin.php/'
  });
  store.commit('changeExternalurl', {
    opo: 'https://opo.giant.com.cn',
    club: 'https://club.giant.com.cn',
    crshop: 'https://jf.giant.com.cn',
    shop: 'https://e.giant.com.cn',
    banner: 'https://opo.giant.com.cn/opo/index.php/api/get_app_banner_list',
    chat: 'https://chat.giant.com.cn',
    insure: 'https://insure.giant.com.cn',
    giantqrcode: 'https://qrcode.giant.com.cn/front/toQuerybike',
    GIANT_CDN: 'https://giant-images.oss-cn-shanghai.aliyuncs.com/eshop/static',//捷安特CDN
    officialwebsite_usercenter: 'https://u-api.giant.com.cn/index.php',
    insure_gw: 'https://insure-gw.giant.com.cn',
  });
  store.commit('changeEnvironment');

  store.commit('updateState', {
    label: 'siteUrl',
    data: 'https://insure.giant.com.cn/#/',
  });
}



//导出store
export default store;


// WEBPACK FOOTER //
// ./src/store/index.js